var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3.5px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.5,46.2v-6.9h-30.1c-3.8,0-6.9,3.1-6.9,6.9M22.6,53.2h18.5c2.6,0,3.9,0,4.9-.5.9-.4,1.6-1.2,2-2,.5-1,.5-2.3.5-4.9V14.3c0-2.6,0-3.9-.5-4.9-.4-.9-1.2-1.6-2-2-1-.5-2.3-.5-4.9-.5h-18.5c-3.9,0-5.8,0-7.3.8-1.3.7-2.4,1.7-3,3-.8,1.5-.8,3.4-.8,7.3v24.1c0,3.9,0,5.8.8,7.3.7,1.3,1.7,2.4,3,3,1.5.8,3.4.8,7.3.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIc);
export default __webpack_public_path__ + "static/media/book_ic.f252a912b6fb277ef4d90df4612c4461.svg";
export { ForwardRef as ReactComponent };